import { Link, useSearchParams } from "react-router-dom";
import { TopBar } from "@/components/Shell";
import { CANDIDATE } from "@/constants/testIds";
import { CheckCircle2, Home } from "lucide-react";

export default function ApplySuccessPage() {
  const [params] = useSearchParams();
  const ref = params.get("ref") || "";
  return (
    <div className="min-h-screen">
      <TopBar mode="public" />
      <div className="max-w-3xl mx-auto px-5 lg:px-8 py-20 text-center fade-up">
        <div className="mx-auto w-16 h-16 border-2 border-black bg-[rgb(var(--flame))] grid place-items-center mb-6">
          <CheckCircle2 size={30} strokeWidth={2.5} />
        </div>
        <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-black/60 mb-2">
          Application received
        </div>
        <h1 className="font-display text-5xl md:text-6xl uppercase">You&apos;re in the queue.</h1>
        <p className="mt-5 text-black/75 max-w-xl mx-auto">
          Save your reference number — you can use it when contacting the
          project team. A reviewer will verify your documents and update your
          status.
        </p>

        <div className="brut-card mt-9 inline-block px-8 py-6" data-testid={CANDIDATE.successRef}>
          <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-black/60">
            Your reference
          </div>
          <div className="font-display text-4xl mt-1 tracking-tight">{ref || "—"}</div>
        </div>

        <div className="mt-10 flex justify-center gap-3">
          <Link to="/" data-testid={CANDIDATE.successHome} className="btn-brut btn-flame">
            <Home size={16} /> Back home
          </Link>
        </div>
      </div>
    </div>
  );
}
